import { createContext, useContext, useCallback, useMemo } from 'react'

const LocalStorageContext = createContext(null)

export function LocalStorageProvider({ children }) {
  const getValue = useCallback((key) => {
    try {
      const item = localStorage.getItem(key)
      if (item === null) {
        return null
      }
      return JSON.parse(item)
    } catch {
      return localStorage.getItem(key)
    }
  }, [])

  const setValue = useCallback((key, value) => {
    try {
      const serialized = typeof value === 'object' ? JSON.stringify(value) : value
      localStorage.setItem(key, serialized)
    } catch (error) {
      console.error('Error saving to localStorage:', error)
    }
  }, [])

  const removeValue = useCallback((key) => {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from localStorage:', error)
    }
  }, [])

  const value = useMemo(() => ({ getValue, setValue, removeValue }), [getValue, setValue, removeValue])

  return (
    <LocalStorageContext.Provider value={value}>
      {children}
    </LocalStorageContext.Provider>
  )
}

export function useLocalStorage() {
  const context = useContext(LocalStorageContext)
  if (!context) {
    throw new Error('useLocalStorage must be used within a LocalStorageProvider')
  }
  return context
}
